var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ResourceCards",
    {
      staticClass: "fullWidthCardRes",
      attrs: { disabled: false, footerPadding: "px-0" },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "flex gap-1 w-full skills-footer items-center px-4 mt-2 cardBorder",
                },
                [
                  _vm._v(" Tags: "),
                  _vm.skills.length > 0
                    ? _c(
                        "div",
                        { staticClass: "flex flex-row gap-1 items-center" },
                        [
                          _vm._l(_vm.skills.slice(0, 3), function (skill) {
                            return _c(
                              "div",
                              {
                                key: skill.skill.name,
                                staticClass: "skills-chip",
                              },
                              [_vm._v(" " + _vm._s(skill.skill.name) + " ")]
                            )
                          }),
                          _vm.skills.length > 3
                            ? _c("div", [
                                _c("div", { staticClass: "skills-chip-plus" }, [
                                  _vm._v(
                                    " +" + _vm._s(_vm.skills.length - 3) + " "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.skills.length === 0
                    ? _c("div", [_vm._v("n/a")])
                    : _vm._e(),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col w-full p-4 pb-0" },
        [
          _c("div", { staticClass: "flex flex-row justify-between pb-2" }, [
            _c(
              "div",
              { staticClass: "flex flex-col gap-2" },
              [
                !_vm.isEmailUnconfirmed &&
                !_vm.contractor?.user.archived &&
                !_vm.contractor?.user?.pending_invite
                  ? _c("Badge", {
                      staticClass: "text-badge capitalize",
                      attrs: {
                        color: _vm.BadgeColor.ACTIVE,
                        value: "Active",
                        styleClasses: "h-auto py-0.5 px-2",
                      },
                    })
                  : _vm._e(),
                _vm.contractor?.user.archived &&
                !_vm.contractor?.user?.pending_invite
                  ? _c("Badge", {
                      staticClass: "text-storm-gray bg-gray-tabs capitalize",
                      attrs: {
                        value: "Archived",
                        color: "text-storm-gray",
                        styleClasses: "h-auto py-0.5 px-2",
                      },
                    })
                  : _vm._e(),
                _vm.isEmailUnconfirmed &&
                !_vm.contractor?.user.archived &&
                !_vm.contractor?.user?.pending_invite
                  ? _c("Badge", {
                      attrs: {
                        color: _vm.BadgeColor.WARNING,
                        styleClasses: "h-auto py-0.5 px-2",
                        value: _vm.emailStatusText,
                      },
                    })
                  : _vm._e(),
                _vm.contractor?.user?.pending_invite
                  ? _c("Badge", {
                      attrs: {
                        color: _vm.BadgeColor.INTERNAL,
                        styleClasses: "h-auto py-0.5 px-2",
                        value: "Internal",
                      },
                    })
                  : _vm._e(),
                _c("span", { staticClass: "hidden" }, [_vm._v("space")]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "flex flex-row gap-2 items-start" },
              [
                _vm.isAccessGranted
                  ? _c("ToggleFavorite", {
                      attrs: {
                        currentUserId: _vm.currentUserId,
                        contractorUserId: _vm.contractor.user.id,
                        didLike:
                          _vm.contractor.user.favorited_by_users.length > 0,
                        favorites: _vm.contractor.user.favorited_by_users,
                      },
                      on: {
                        updated: function ($event) {
                          return _vm.$emit("cardDataUpdated")
                        },
                      },
                    })
                  : _vm._e(),
                !_vm.isCardDisabled
                  ? _c(
                      "button",
                      {
                        on: {
                          click: _vm.message,
                          mouseover: function ($event) {
                            _vm.isHoveredChat = true
                          },
                          mouseout: function ($event) {
                            _vm.isHoveredChat = false
                          },
                        },
                      },
                      [
                        !_vm.isHoveredChat
                          ? _c("ChatIcon", { staticClass: "h-4 w-4" })
                          : _vm._e(),
                        _vm.isHoveredChat
                          ? _c("ChatIconHover", { staticClass: "h-4 w-4" })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "flex w-full justify-center h-fit mt-2" },
            [
              _c(
                "RouterLink",
                { attrs: { to: _vm.contractorPageRoute } },
                [
                  _c("ResourceAvatar", {
                    staticClass: "cursor-pointer text-primary-600",
                    attrs: {
                      image: _vm.managerAvatar,
                      initial: _vm.managerInitials,
                      disabled: _vm.isCardDisabled,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex items-center justify-center pt-2" },
            [
              _c(
                "RouterLink",
                {
                  staticClass: "mr-[40px]",
                  attrs: { to: _vm.contractorPageRoute },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "font-normal text-lg text-default-500 hover:text-primary-500 flex flex-row blueText items-center cursor-pointer gap-2",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-row items-center justify-flex-start text-center minHeightTitle",
                        },
                        [_vm._v(" " + _vm._s(_vm.managerFullName) + " ")]
                      ),
                      _c(
                        "div",
                        { staticClass: "flag-wrapper" },
                        [
                          _vm.country
                            ? _c("country-flag", {
                                staticClass: "country-flag",
                                attrs: { country: _vm.country, size: "small" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "flex flex-row justify-center text-default-500 text-base font-normal items-center",
            },
            [
              _c("p", { staticClass: "mr-2 minHeightName text-center" }, [
                _vm._v(
                  _vm._s(_vm.managerJobTitle ? _vm.managerJobTitle : "n/a")
                ),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex justify-center text-default-grey text-sm font-medium text-center minHeightName",
            },
            [_vm._v(" " + _vm._s(_vm.managerLocation) + " ")]
          ),
          _c("ContractorRating", {
            staticClass: "flex items-center justify-center w-full mt-3 mb-1",
            attrs: {
              ratingTotal: _vm.contractor.ratingTotal,
              ratingCount: _vm.contractor.ratingTotal.aggregate.count,
            },
          }),
          this.projects !== null
            ? _c("ActionSection", {
                attrs: {
                  isContractor: "true",
                  companyId: _vm.companyId,
                  contractor: _vm.contractor,
                  contractorId: _vm.contractor.id,
                  resourceHeight: "resourceActionHeight",
                  actionObject: _vm.getActionSectionValues,
                  currentUser: _vm.currentUser,
                  manager: _vm.contractor,
                  parentStyle: "customHeightSkillRate",
                  onActivateManager: _vm.onActivateManager,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "rightSection",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col items-center w-full",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "projects-value flex flex-col" },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.contractorMinRate) +
                                        _vm._s(_vm.contractorMaxRate)
                                    ),
                                  ]),
                                  _vm.contractorMinRate && _vm.contractorMaxRate
                                    ? _c("p", [
                                        _vm._v(_vm._s(_vm.contractorRateUnit)),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                              _c("div", { staticClass: "projects-name" }, [
                                _vm._v(" Rate "),
                              ]),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2629616875
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }